import FleetHelper from 'features/Fleet/fleetHelper';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useState } from 'react';

ChangeFleetPasswordView.propTypes = {
    fleet: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function ChangeFleetPasswordView({ fleet, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    // MARK: ---- FUNCTIONS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (!Utils.isValid(newPassword) ||
            !Utils.isValid(confirmPassword)
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }
        if (Utils.isValid(newPassword) && newPassword?.length < 6) {
            ToastHelper.showError('Độ dài mật khẩu phải lớn hơn hoặc bằng 6');
            return;
        }
        if (_.isEqual(newPassword, confirmPassword)) {
            try {
                let res;
                if (!!fleet?.agencyId) {
                    const params = {
                        agencyId: fleet?.agencyId,
                        newPassword: newPassword,
                    };
                    setLoading(true);
                    res = await FleetHelper.API.requestResetFleetPassword(params);
                } else {
                    const params = {
                        userId: fleet?.userId,
                        newPassword: newPassword,
                    };
                    setLoading(true);
                    res = await FleetHelper.API.requestResetUserPassword(params);
                }
                if (res && _.isBoolean(res)) {
                    ToastHelper.showSuccess('Đặt lại mật khẩu thành công');
                    onDone();
                } else if (_.isString(res)) {
                    ToastHelper.showError(res);
                }
            } catch (error) {
                ToastHelper.showError('Đã xảy ra lỗi khi đặt lại mật khẩu');
                console.error('Error resetting password:', error);
            } finally {
                setLoading(false);
            }
        } else {
            ToastHelper.showError('Mật khẩu không khớp')
        }
    };

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* mat khau moi */}
                <div className="col-12 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Mật khẩu mới', true)}
                        <KTFormInput
                            type={KTFormInputType.customPassword}
                            placeholder="Nhập mật khẩu mới"
                            name="newPassword"
                            value={newPassword}
                            onChange={(value) => {
                                setNewPassword(value);
                            }}
                            enableCheckValid={readyToValidate}
                            isValid={Utils.isValid(newPassword) && newPassword?.length >= 6}
                            isTouched={true}
                            feedbackText={!Utils.isValid(newPassword)
                                ? 'Bạn chưa nhập mật khẩu mới'
                                : newPassword?.length < 6
                                    ? 'Độ dài mật khẩu phải lớn hơn hoặc bằng 6' : ''
                            }
                        />
                    </div>
                </div>
                {/* nhap lai mat khau moi */}
                <div className="col-12 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Nhập lại mật khẩu mới', true)}
                        <KTFormInput
                            type={KTFormInputType.customPassword}
                            placeholder="Nhập mật khẩu mới"
                            name="confirmPassword"
                            value={confirmPassword}
                            onChange={(value) => {
                                setConfirmPassword(value);
                            }}
                            enableCheckValid={readyToValidate}
                            isValid={Utils.isValid(confirmPassword) && _.isEqual(newPassword, confirmPassword)}
                            isTouched={true}
                            feedbackText={
                                !Utils.isValid(confirmPassword)
                                    ? 'Bạn chưa nhập lại mật khẩu mới'
                                    : !_.isEqual(newPassword, confirmPassword)
                                        ? 'Mật khẩu không khớp'
                                        : ''
                            }
                        />
                    </div>
                </div>
            </div>

            <div
                className="d-flex align-items-center justify-content-center gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
                {UIHelper.buildGreenButton('Đặt lại mật khẩu', handleSubmit, null, true, loading)}
            </div>
        </div>
    );
}

export default ChangeFleetPasswordView;
